import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import * as fromSealingElements from '../fromSealingElement.barrel'
import * as Sentry from '@sentry/angular';
import { map, tap } from "rxjs";

@Injectable()
export class FailureEffects {
  constructor(
    private actions$: Actions,
  ) { }

  onFailure$ = createEffect(() => this.actions$.pipe(
    ofType(fromSealingElements.loadEquipmentTypesFail),
    tap(action => Sentry.captureException(action, { level: 'error' }))
  ), { dispatch: false });
}
